import React from 'react';
import { motion } from 'framer-motion';
import styles from './Skeleton.module.css';

interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

export function Skeleton({ className = '', style }: SkeletonProps) {
  return <div className={[styles.skeleton, className].filter(Boolean).join(' ')} style={style} />;
}

export function PhotoCardSkeleton() {
  return (
    <div className={styles['photo-card']}>
      <Skeleton className={[styles['aspect-square'], styles['w-full']].join(' ')} />
    </div>
  );
}

export function AlbumCardSkeleton() {
  return (
    <motion.div
      className={styles['album-card']}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      {/* thumbnail */}
      <Skeleton className={styles['album-thumb']} />
      <div className={styles['album-card-body']}>
        {/* name + photo-count badge */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.5rem' }}>
          <Skeleton className={[styles.h5, styles['w-48']].join(' ')} />
          <Skeleton className={[styles.h4, styles['w-16'], styles['rounded-full']].join(' ')} />
        </div>
        {/* creator · event meta */}
        <Skeleton className={[styles.h3, styles['w-3-4']].join(' ')} />
        {/* joined date — right-aligned like real card */}
        <div className={styles['album-card-footer']}>
          <Skeleton className={[styles.h3, styles['w-1-2']].join(' ')} />
        </div>
      </div>
    </motion.div>
  );
}

export function OverlayCardSkeleton() {
  return (
    <motion.div
      className={styles['overlay-card']}
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <Skeleton className={[styles['aspect-square'], styles['w-full']].join(' ')} />
      <div className={styles['overlay-card-body']}>
        <Skeleton className={[styles.h3, styles['w-3-4'], styles['mb-1']].join(' ')} />
        <Skeleton className={[styles.h3, styles['w-1-2']].join(' ')} />
      </div>
    </motion.div>
  );
}

export function EventCardSkeleton() {
  return (
    <motion.div
      className={styles['event-card']}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      {/* top-right badge */}
      <div className={styles['event-card-top']}>
        <Skeleton className={[styles.h5, styles['w-16'], styles['rounded-full']].join(' ')} />
      </div>
      {/* bottom content */}
      <div className={styles['event-card-bottom']}>
        <Skeleton className={[styles.h5, styles['w-3-4'], styles['mb-2']].join(' ')} />
        <div className={styles['event-card-chips']}>
          <Skeleton className={[styles.h4, styles['w-14'], styles['rounded-full']].join(' ')} />
          <Skeleton className={[styles.h4, styles['w-14'], styles['rounded-full']].join(' ')} />
        </div>
        <Skeleton className={[styles.h3, styles['w-2-3']].join(' ')} />
      </div>
    </motion.div>
  );
}
